import * as React from "react";
import classNames from "classnames";
import styles from "./Main.module.css";

interface MainProps {
  className?: string;
  children?: React.ReactNode;
}

const Main: React.FC<MainProps> = ({ className, children }) => (
  <main id="main" className={classNames(className, styles.wrapper)}>
    {children}
  </main>
);

export default Main;
